import CustomButton from "@/src/lib/ui/Button";

const DeleteTestConfirmation = ({
    onConfirmTestDeleteHandler,
    onClose,
    open,
    isPending,
}) => {
    return (
        <>
            <div>
                <p className="text-black text-xl font-bold max-w-68 text-center mx-auto w-full">
                    Are You Sure want to delete the{" "}
                    <span className="text-primary">
                        {open?.items?.itemName}
                    </span>{" "}
                    test
                </p>

                <p className="max-w-72 text-center mx-auto pt-3 text-gray-700">
                    This Action cannot be undone. Are you sure you want to
                    continue
                </p>

                <div className="flex flex-row justify-between gap-2 pt-10">
                    <CustomButton
                        fullWidth
                        variant="outlined"
                        onClick={onClose}
                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        disabled={isPending}
                        fullWidth
                        variant="contained"
                        onClick={() => onConfirmTestDeleteHandler(open)}
                    >
                        Confirm
                    </CustomButton>
                </div>
            </div>
        </>
    );
};

export default DeleteTestConfirmation;
